import ObjectId from 'bson-objectid';
import { uploadWithSignedUrl } from './';

async function uploadMedia(data, idx) {
  const documentId = ObjectId().toString();

  let finalData = {
    uri: '',
    thumbnail: ''
  };

  if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_AWS_S3_BASE_URL) {
    console.warn('Data not uploaded');
    return finalData;
  }

  // Video case: uri is a blob: object URL string, actual File is in data.file
  if (typeof data.uri === 'string' && data.file instanceof File) {
    const file = data.file;
    const ext = file.type.split('/')[1] || 'mp4';
    const name = `${documentId}-${idx}.${ext}`;
    finalData.uri = await uploadWithSignedUrl(name, file.type, file);
    return finalData;
  }

  // Image case: uri and thumbnail are Blobs
  for await (let key of Object.keys(data)) {
    if (!['uri', 'thumbnail'].includes(key)) continue;
    const blobData = data[key];
    if (!(blobData instanceof Blob)) continue;

    const mimeType = blobData.type.toLowerCase() || 'image/jpeg';
    const ext = mimeType.split('/')[1];
    const name = `${documentId}-${idx}${key === 'thumbnail' ? '-thumbnail' : ''}.${ext}`;
    const fileObj = new File([blobData], name, { type: mimeType });
    finalData[key] = await uploadWithSignedUrl(name, mimeType, fileObj);
  }

  return finalData;
}

export default uploadMedia;
